import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-progress-bar__container"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($options.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "gfu-progress-bar__item" }, [
          _createElementVNode("div", { class: "gfu-progress-bar__value" })
        ], -1 /* CACHED */)
      ]))]))
    : _createCommentVNode("v-if", true)
}